import { GET_GRADING_SCALES } from '@src/graphql/queries/gradingScale';
import { GradingScaleType, } from '@src/types';
import { usePaginatedFetchItems } from 'pe-core-frontend';
import { useMemo } from 'react';
export const convertToBaseGrade = (gradeLevels, type) => {
    if (type === GradingScaleType.CATEGORY) {
        const itemsSrc = Array.isArray(gradeLevels) ? gradeLevels[0].items : gradeLevels?.items ?? [];
        const items = itemsSrc.map((it) => ({
            value: it.value,
            label: it.label,
            gradeEquivalent: it.gradeEquivalent ?? it.grade_equivalent,
        }));
        return { items };
    }
    // RANGE
    return {
        minValue: gradeLevels?.minValue ?? gradeLevels?.min_value,
        maxValue: gradeLevels?.maxValue ?? gradeLevels?.max_value,
    };
};
export const useGradingScales = ({ searchText, includeCountries, initialPageSize = 100, }) => {
    const { page, setPage, pageSize, setPageSize, total, items: gradingScales, loading, error, find, orderBy, orderByDir, setOrderBy, setOrderByDir, refetch, } = usePaginatedFetchItems({
        spec: { name: searchText, includeCountries },
        fetchQuery: GET_GRADING_SCALES,
        dataProp: 'gradingScales',
        initialPageSize,
    });
    // Convert raw items to typed GradingScale
    const typedGradingScales = useMemo(() => {
        return gradingScales.map(gs => ({
            ...gs,
            gradeLevels: convertToBaseGrade(gs.gradeLevels, gs.gradingScaleType),
        }));
    }, [gradingScales]);
    return {
        gradingScales: typedGradingScales,
        loading,
        page,
        pageSize,
        setPage,
        setPageSize,
        error,
        total,
        find,
        orderBy,
        orderByDir,
        setOrderBy,
        setOrderByDir,
        refetch,
    };
};
